import { useEffect, useState } from "react";
import { useLang } from "../lib/i18n";
import { imageUrl } from "../lib/adminApi";
import { Overline } from "../components/ui-vision";
import { HomeCta } from "../components/HomeCta";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STR = {
  fr: { overline: "Nos réalisations", view: "Voir le projet", empty: "Nos réalisations seront bientôt disponibles." },
  nl: { overline: "Onze realisaties", view: "Bekijk het project", empty: "Onze realisaties zijn binnenkort beschikbaar." },
};

export default function RealisationsPage() {
  const { lang } = useLang();
  const s = STR[lang];
  const [projects, setProjects] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`${API}/projects`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setProjects(Array.isArray(d) ? d : []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <section className="pt-[88px] md:pt-[130px] pb-6 md:pb-[50px] max-w-[1440px] mx-auto px-6 md:px-12" data-testid="realisations">
        <Overline className="mb-8 md:mb-10">{s.overline}</Overline>

        {loaded && projects.length === 0 ? (
          <p className="text-white/45 font-light text-sm" data-testid="realisations-empty">{s.empty}</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {projects.map((p, i) => (
              <article
                key={p.id}
                data-testid={`project-card-${i}`}
                className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden hover:border-white/20 transition-colors duration-300"
              >
                <div className="relative overflow-hidden aspect-[4/3] bg-white/[0.04]">
                  {p.image_id && (
                    <img
                      src={imageUrl(p.image_id)}
                      alt={p.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
                    />
                  )}
                </div>
                <div className="flex flex-col flex-1 p-6">
                  {p.type?.[lang] && (
                    <span className="text-xs uppercase tracking-[0.25em] text-accent-yellow mb-3">{p.type[lang]}</span>
                  )}
                  <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight leading-tight">{p.title}</h3>
                  {p.loc && <p className="mt-1 text-sm text-white/45">{p.loc}</p>}
                  {p.desc?.[lang] && <p className="mt-3 text-sm text-white/55 font-light leading-relaxed">{p.desc[lang]}</p>}
                  <span className="mt-5 inline-flex items-center gap-2 text-sm text-white/60 group-hover:text-accent-yellow transition-colors duration-300">
                    {s.view}
                    <ArrowUpRight
                      size={15}
                      className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                    />
                  </span>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
      <HomeCta />
    </>
  );
}
